import React from 'react';
import {
  AppBar,
  IconButton,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LogoutIcon from '@mui/icons-material/Logout';
import { useThemeMode } from '../theme';
import { useAuth } from '../auth/AuthContext';
import { SIDEBAR_WIDTH } from './Sidebar';

interface HeaderProps {
  onMenuClick: () => void;
  title?: string;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick, title }) => {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const { mode, toggleMode } = useThemeMode();
  const { signOut } = useAuth();

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        width: isMdUp ? `calc(100% - ${SIDEBAR_WIDTH}px)` : '100%',
        ml: isMdUp ? `${SIDEBAR_WIDTH}px` : 0,
        bgcolor: 'background.paper',
        color: 'text.primary',
        borderBottom: '1px solid',
        borderColor: 'divider',
        backdropFilter: 'blur(8px)',
        backgroundColor: theme.palette.mode === 'light'
          ? 'rgba(255,255,255,0.85)'
          : 'rgba(36,41,40,0.85)',
      }}
    >
      <Toolbar>
        {!isMdUp && (
          <IconButton
            edge="start"
            onClick={onMenuClick}
            sx={{ mr: 2 }}
            aria-label="open menu"
          >
            <MenuIcon />
          </IconButton>
        )}
        <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 600 }}>
          {title || 'BeMoTechs Invoice'}
        </Typography>
        <IconButton onClick={signOut} aria-label="sign out" sx={{ mr: 1 }}>
          <LogoutIcon />
        </IconButton>
        <IconButton onClick={toggleMode} aria-label="toggle theme">
          {mode === 'light' ? <DarkModeIcon /> : <LightModeIcon />}
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
